module.exports = {
  oneDigit: require("./oneDigit"),
  twoDigit: require("./twoDigit"),
  threeDigit: require("./threeDigit")
};
